export const ruleTemplates = [
    `.ta-Swiper.%class%::-webkit-scrollbar { display: none }`,
    `.ta-Swiper.%class% { scrollbar-width: none }`,
];
